const axios = require('axios').default

const findCulturalItemByUuidUrl = `${process.env.API_BASE_URL}meta/culturalItems/search/findByUuid`
const findModel3DByUuidUrl = `${process.env.API_BASE_URL}meta/model3Ds/search/findByUuid`
const nexusFilesRoot = `${process.env.API_BASE_URL}images/3d/db/`
const snapshotUrl = `${process.env.API_BASE_URL}api/auth/can`

function getModel3DData(s) {
  return {
    uuid: s.uuid,
    sgtt: s.sgtt,
    modelUrl: `${nexusFilesRoot}${s.uuid}.nxz`,
    configurationUrl: `${nexusFilesRoot}${s.uuid}.json`
  }
}

function getModel3DsMetadataFromCulturalItem(culturalItemUuid, apiClient = axios) {
  let modelsLinks = []
  let params = { uuid: culturalItemUuid }
  return apiClient
    .get(findCulturalItemByUuidUrl, { params })
    .then(culturalItemResponse => {
      const model3DsLink = culturalItemResponse?.data?._links?.model3Ds?.href
      if (!model3DsLink) {
        throw new Error(`No 3D models link found for cultural item ${culturalItemUuid}`)
      }

      let sizeParams = { size: 1000 }
      return apiClient.get(model3DsLink, { params: sizeParams })
    })
    .then(models => {
      const model3Ds = models?.data?._embedded?.model3Ds || []
      model3Ds.map(s => modelsLinks.push(getModel3DData(s)))
      return { modelsLinks: modelsLinks }
    })
}

function getSingleModel3DMetadata(uuid, apiClient = axios) {
  let modelsLinks = []
  let params = { uuid: uuid }
  return apiClient
    .get(findModel3DByUuidUrl, { params })
    .then(model3DResponse => model3DResponse.data)
    .then(model3D => {
      modelsLinks.push(getModel3DData(model3D))
      return { modelsLinks: modelsLinks }
    })
}

async function getSnapshotPermission(apiClient = axios) {
  try {
    const response = await apiClient.post(
      snapshotUrl,
      { key: 'viewer.3d.screenshot.creation' },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )

    return response.status === 200
  } catch (e) {
    console.error('Permission check failed:', e)
    return false
  }
}

export default { getModel3DsMetadataFromCulturalItem, getSingleModel3DMetadata, getSnapshotPermission }
